import React from 'react';

// Component to highlight the searched text in the results
const HighlightText = ({ text, searchTerm }) => {
  if (!searchTerm || !text) return text;
  
  const searchTermLower = searchTerm.toLowerCase().trim();
  if (searchTermLower === '') return text;
  
  const textStr = String(text);
  const textLower = textStr.toLowerCase();
  const index = textLower.indexOf(searchTermLower);
  
  if (index === -1) return text;
  
  const beforeMatch = textStr.substring(0, index);
  const match = textStr.substring(index, index + searchTermLower.length);
  const afterMatch = textStr.substring(index + searchTermLower.length);
  
  return (
    <>
      {beforeMatch}
      <span style={{ backgroundColor: 'yellow', fontWeight: 'bold' }}>
        {match}
      </span>
      {afterMatch}
    </>
  );
};

export default HighlightText;